// Métadonnées légères : les gros JSON sont chargés à la demande.

const invoiceTemplatesRaw = {
  // Nouveau modèle : ajoutez isNew: true sur sa définition.
  apple: { name: "Apple" },
  adidas: { name: "Adidas" },
  backmarket: { name: "Back Market" },
  boulanger: { name: "Boulanger" },
  balenciaga: { name: "Balenciaga" },
  bape: { name: "BAPE" },
  chanel: { name: "Chanel" },
  fnac: { name: "Fnac" },
  darty: { name: "Darty" },
  hermes: { name: "Hermès" },
  nike: { name: "Nike" },
  zalando: { name: "Zalando" },
  amiparis: { name: "AMI Paris" },
  trapstar: { name: "Trapstar" },
  carrefour: { name: "Carrefour" },
  mediamarkt: { name: "MediaMarkt" },
  pixmania: { name: "Pixmania" },
  histoiredor: { name: "Histoire d'Or" },
  jacquemus: { name: "Jacquemus" },
  loropiana: { name: "Loro Piana" },
  louboutin: { name: "Louboutin" },
  viviennewestwood: { name: "Vivienne Westwood" },
  moncler: { name: "Moncler" },
  louisvuitton: { name: "Louis Vuitton" },
  footlocker: { name: "Foot Locker" },
  farfetch: { name: "Farfetch" },
  rimowa: { name: "Rimowa" },
  dior: { name: "Dior" },
  galerieslafayette: { name: "Galeries Lafayette" },
};

export const invoiceTemplates = Object.fromEntries(
  Object.entries(invoiceTemplatesRaw).sort(
    ([, a], [, b]) =>
      a.name.localeCompare(
        b.name,
        'fr',
        { sensitivity: 'base' }
      )
  )
);

const invoiceTemplateLoaders = {
  apple: () => import('./apple.json'),
  adidas: () => import('./adidas.json'),
  backmarket: () => import('./backmarket.json'),
  boulanger: () => import('./boulanger.json'),
  balenciaga: () => import('./balenciaga.json'),
  bape: () => import('./bape.json'),
  chanel: () => import('./chanel.json'),
  fnac: () => import('./fnac.json'),
  darty: () => import('./darty.json'),
  hermes: () => import('./hermes.json'),
  nike: () => import('./nike.json'),
  zalando: () => import('./zalando.json'),
  amiparis: () => import('./amiparis.json'),
  trapstar: () => import('./trapstar.json'),
  carrefour: () => import('./carrefour.json'),
  mediamarkt: () => import('./mediamarkt.json'),
  pixmania: () => import('./pixmania.json'),
  histoiredor: () => import('./histoiredor.json'),
  jacquemus: () => import('./jacquemus.json'),
  loropiana: () => import('./loropiana.json'),
  louboutin: () => import('./louboutin.json'),
  viviennewestwood: () => import('./viviennewestwood.json'),
  moncler: () => import('./moncler.json'),
  louisvuitton: () => import('./louisvuitton.json'),
  footlocker: () => import('./footlocker.json'),
  farfetch: () => import('./farfetch.json'),
  rimowa: () => import('./rimowa.json'),
  dior: () => import('./dior.json'),
  galerieslafayette: () => import('./galerieslafayette.json'),
};

export const loadInvoiceTemplate = async (id) => {
  const loader =
    invoiceTemplateLoaders[id] ||
    invoiceTemplateLoaders.apple;

  const module = await loader();

  return module?.default ?? module;
};

export const getInvoiceTemplate = (id) =>
  invoiceTemplates[id] ||
  invoiceTemplates.apple;

export default invoiceTemplates;